<template>
	<div class="full-page-height">
		<zoom-center-transition>
			<div class="slider-right-controls" v-if="currentPage != '00'">
				<div class="top-arrow" @click="$refs.fullpage.api.moveSectionUp()"></div>
				<zoom-center-transition v-for="i in 16" :key="'pi'+i"><div v-if="currentPage == ('0'+i).slice(-2)" class="page">{{ ('0'+i).slice(-2) }}<small>/ 15</small></div></zoom-center-transition>
				<div class="bottom-arrow" @click="$refs.fullpage.api.moveSectionDown()"></div>
			</div>
		</zoom-center-transition>
		<ul class="slider-bottom-controls">
			<li :class="{ 'active': currentPage == '00' }" @click="$refs.fullpage.api.moveTo(1)">00</li>
			<li :class="{ 'active-bar': currentPage == '00' }" class="bar"><div :style="{ width: '0%' }"></div></li>
			<template v-for="i in 15">
				<li :key="'pi1'+i" :class="{ 'active': currentPage == (i<10?'0'+i:i) }" @click="$refs.fullpage.api.moveTo(i+1)">{{ ('0'+i).slice(-2) }}</li>
				<li :key="'pi2'+i" :class="{ 'active-bar': currentPage == ('0'+i).slice(-2) }" class="bar"><div :style="{ width: (100/15)*i+'%' }"></div></li>
			</template>
			<!-- <li :class="{ 'active': currentPage == '02' }" @click="$refs.fullpage.api.moveTo(2)">02</li>
			<li :class="{ 'active-bar': currentPage == '02' }" class="bar"><div style="width: 50%"></div></li>
			<li :class="{ 'active': currentPage == '03' }" @click="$refs.fullpage.api.moveTo(3)">03</li>
			<li :class="{ 'active-bar': currentPage == '03' }" class="bar"><div style="width: 75%"></div></li>
			<li :class="{ 'active': currentPage == '04' }" @click="$refs.fullpage.api.moveTo(4)">04</li>
			<li :class="{ 'active-bar': currentPage == '04' }" class="bar"><div style="width: 100%"></div></li> -->
		</ul>
		<fade-transition>
			<full-page v-show="showFirst" ref="fullpage" :options="options">
				<div class="section slide summary">
					<div class="slide-container">
						<div class="datas-container" style="align-items: center;margin-bottom: 0;margin-top: 5rem">
							<fade-transition>
								<div class="datasA" v-show="showSecond">
									<div class="summary">
										<div>
											<div class="summary-influencer single nabilla" @click="$refs.fullpage.api.moveTo(9)"></div>
										</div>
										<div>
											<div class="summary-influencer julien" @click="$refs.fullpage.api.moveTo(2)"></div>
											<div class="summary-influencer thomas" @click="$refs.fullpage.api.moveTo(10)"></div>
										</div>
										<div>
											<div class="summary-influencer single jessica" @click="$refs.fullpage.api.moveTo(7)"></div>
										</div>
										<div>
											<div class="summary-influencer manon" @click="$refs.fullpage.api.moveTo(3)"></div>
											<div class="summary-influencer thibault" @click="$refs.fullpage.api.moveTo(8)"></div>
										</div>
										<div>
											<div class="summary-influencer single nore" @click="$refs.fullpage.api.moveTo(14)"></div>
										</div>
										<div>
											<div class="summary-influencer title" @click="$refs.fullpage.api.moveTo(2)"></div>
											<div class="summary-influencer maeva" @click="$refs.fullpage.api.moveTo(6)"></div>
										</div>
										<div>
											<div class="summary-influencer single kamila" @click="$refs.fullpage.api.moveTo(13)"></div>
										</div>
										<div>
											<div class="summary-influencer laura" @click="$refs.fullpage.api.moveTo(4)"></div>
											<div class="summary-influencer giovanni" @click="$refs.fullpage.api.moveTo(16)"></div>
										</div>
										<div>
											<div class="summary-influencer single hillary" @click="$refs.fullpage.api.moveTo(15)"></div>
										</div>
										<div>
											<div class="summary-influencer nikola" @click="$refs.fullpage.api.moveTo(5)"></div>
											<div class="summary-influencer laurent" @click="$refs.fullpage.api.moveTo(12)"></div>
										</div>
										<div>
											<div class="summary-influencer single jazz" @click="$refs.fullpage.api.moveTo(11)"></div>
										</div>
									</div>
								</div>
							</fade-transition>
							<zoom-center-transition>
								<div v-show="showThird" @click="$refs.fullpage.api.moveSectionDown()" class="bottom-arrow-mobile"></div>
							</zoom-center-transition>
						</div>
						<fade-transition>
							<div v-show="showThird" class="bottom">
								<div class="container">
									<div class="social">
										<!--<router-link to="/contact"><span class="instagram"></span></router-link>-->
										<!-- <router-link to="/contact"><span class="facebook"></span></router-link> -->
									</div>
									<!-- <div class="author">
										<i>Julien Tanti</i>
										<br>
										&copy; Les Marseillais
									</div> -->
								</div>
							</div>
						</fade-transition>
					</div>
				</div>

				<div v-for="(influencer, key) in influencers" :key="influencer.id" class="section slide" :class="[ influencer.id ]">
					<div class="slide-container">
						<div class="datas-container">
							<div class="space" v-if="key % 2 != 0"></div>
							<div class="datas">
								<div class="title">{{ influencer.name }}</div>
								<div class="sub-title">{{ influencer.job }}</div>
								<ul class="stats">
									<li class="instagram">{{ influencer.instagramCount }} <small><a href="https://instagram.com/manontanti" target="_blank">@{{ influencer.instagram }}</a></small></li>
									<li v-if="influencer.twitter.length" class="twitter">{{ influencer.twitterCount }} <small><a href="https://twitter.com/ManonMarsault" target="_blank">@{{ influencer.twitter }}</a></small></li>
									<li v-if="influencer.tiktok.length" class="tiktok">{{ influencer.tiktokCount }} <small><a href="https://www.tiktok.com/@manon_marsault" target="_blank">@{{ influencer.tiktok }}</a></small></li>
									<!-- <li class="facebook">{{ influencer.facebookCount }} <small><a href="https://www.tiktok.com/@manon_marsault" target="_blank">@{{ influencer.facebook }}</a></small></li> -->
									<li class="snapchat">{{ influencer.snapchatCount }}<small><a target="_blank">@{{ influencer.snapchat }}</a></small></li>
								</ul>
								<router-link class="button" to="/contact">Request information</router-link>
							</div>
						</div>
						<div class="bottom">
							<div class="container">
								<div class="social">
									<!--<router-link to="/contact"><span class="instagram"></span></router-link>-->
									<!-- <router-link to="/contact"><span class="facebook"></span></router-link> -->
								</div>
								<div class="author">
									<i>{{ influencer.name }}</i>
									<br>
									&copy; {{ influencer.copyright }}
								</div>
							</div>
						</div>
					</div>
				</div>

			</full-page>
		</fade-transition>
	</div>
</template>

<script>
export default {
	name: 'Home',

	data () {
		return {
			showFirst: false,
			showSecond: false,
			showThird: false,
			currentPage: '00',
			options: {
				licenseKey: 'FB1070CE-EC884711-8996B5EE-4752F793',
				menu: '#menu',
				anchors: ['summary', 'julien', 'manon', 'laura', 'nikola', 'maeva', 'jessica', 'thibault', 'nabilla', 'thomas', 'jazz', 'laurent', 'kamila', 'nore', 'hillary', 'giovanni'],
				controlArrows: false,
				onLeave: () => {
					setTimeout(() => {
						this.currentPage = ('0' + (['summary', 'julien', 'manon', 'laura', 'nikola', 'maeva', 'jessica', 'thibault', 'nabilla', 'thomas', 'jazz', 'laurent', 'kamila', 'nore', 'hillary', 'giovanni'].indexOf(document.querySelector('.section.active').getAttribute("data-anchor"))).toString()).slice(-2)
					}, 10)
				},
			},

			influencers: [
				{
					id: 'julien',
					name: 'Julien Tanti',
					job: '',
					instagramCount: '7 Millions Followers',
					instagram: 'julientantiplein',
					tiktokCount: '0.8 Millions Followers',
					tiktok: 'julientantipleinoff',
					twitterCount: '0.4 Millions Followers',
					twitter: 'julienmiam',
					facebookCount: ' Followers',
					facebook: 'julientantiplein',
					snapchatCount: '',
					snapchat: 'julientantiplein',
					copyright: '',
				},
				{
					id: 'manon',
					name: 'Manon Tanti',
					job: '',
					instagramCount: '3.1 Millions Followers',
					instagram: 'manontanti',
					tiktokCount: '1.2 Millions Followers',
					tiktok: 'tantimanon',
					twitterCount: ' Millions Followers',
					twitter: '',
					facebookCount: ' Followers',
					facebook: 'julientantiplein',
					snapchatCount: '',
					snapchat: 'manonmarsault',
					copyright: '',
				},
				{
					id: 'laura',
					name: 'Laura Lempika',
					job: '',
					instagramCount: '2 Millions Followers',
					instagram: 'lauralempika',
					tiktokCount: '0.7 Millions Followers',
					tiktok: 'lauralempika',
					twitterCount: '0.1 Millions Followers',
					twitter: 'lauralempika',
					facebookCount: ' Followers',
					facebook: 'julientantiplein',
					snapchatCount: '',
					snapchat: 'lola-brazilia',
					copyright: '',
				},
				{
					id: 'nikola',
					name: 'Nikola Lozina',
					job: '',
					instagramCount: '1.9 Millions Followers',
					instagram: 'nikolalozina',
					tiktokCount: ' Millions Followers',
					tiktok: 'nikolalozina',
					twitterCount: '0.3 Millions Followers',
					twitter: 'nikolalozina',
					facebookCount: ' Followers',
					facebook: 'julientantiplein',
					snapchatCount: '',
					snapchat: 'lozina8',
					copyright: '',
				},
				{
					id: 'maeva',
					name: 'Maeva Ghennam',
					job: '',
					instagramCount: '3.3 Millions Followers',
					instagram: 'maevaa.ghennam',
					tiktokCount: '3.1 Millions Followers',
					tiktok: 'maevaa.ghennam',
					twitterCount: '0.1 Millions Followers',
					twitter: 'Maevaghennam1',
					facebookCount: ' Followers',
					facebook: 'julientantiplein',
					snapchatCount: '',
					snapchat: 'maevaa.ghennam',
					copyright: '',
				},
				{
					id: 'jessica',
					name: 'Jessica Thivenin',
					job: '',
					instagramCount: '6.1 Millions Followers',
					instagram: 'jessicathivenin',
					tiktokCount: '0.8 Millions Followers',
					tiktok: 'jessicathivenin',
					twitterCount: 'jessicathivenin Millions Followers',
					twitter: '0.5',
					facebookCount: ' Followers',
					facebook: 'julientantiplein',
					snapchatCount: '',
					snapchat: 'jessoff13',
					copyright: '',
				},
				{
					id: 'thibault',
					name: 'Thibault Garcia',
					job: '',
					instagramCount: '4.6 Millions Followers',
					instagram: 'thibaultgarcia',
					tiktokCount: '0.7 Millions Followers',
					tiktok: 'thibaultgarcia',
					twitterCount: '0.8 Millions Followers',
					twitter: 'thibaultgarcia',
					facebookCount: ' Followers',
					facebook: 'julientantiplein',
					snapchatCount: '',
					snapchat: 'thibaultkurog',
					copyright: '',
				},
				{
					id: 'nabilla',
					name: 'Nabilla Vergara',
					job: '',
					instagramCount: '8 Millions Followers',
					instagram: 'nabilla',
					tiktokCount: ' Millions Followers',
					tiktok: '',
					twitterCount: '2.8 Millions Followers',
					twitter: 'Nabilla',
					facebookCount: ' Followers',
					facebook: 'julientantiplein',
					snapchatCount: '',
					snapchat: 'nabilla.v',
					copyright: '',
				},
				{
					id: 'thomas',
					name: 'Thomas Vergara',
					job: '',
					instagramCount: '2.7 Millions Followers',
					instagram: 'vergarathomas',
					tiktokCount: ' Millions Followers',
					tiktok: '',
					twitterCount: '0.8 Millions Followers',
					twitter: 'thomasvergara',
					facebookCount: ' Followers',
					facebook: 'julientantiplein',
					snapchatCount: '',
					snapchat: 'vergaraofficiel',
					copyright: '',
				},
				{
					id: 'jazz',
					name: 'Jazz Correira',
					job: '',
					instagramCount: '4.1 Millions Followers',
					instagram: 'jazztvshow',
					tiktokCount: '0.6 Millions Followers',
					tiktok: 'jazz.correia',
					twitterCount: ' Millions Followers',
					twitter: '',
					facebookCount: ' Followers',
					facebook: 'julientantiplein',
					snapchatCount: '',
					snapchat: '',
					copyright: '',
				},
				{
					id: 'laurent',
					name: 'Laurent Billio',
					job: '',
					instagramCount: '3.2 Millions Followers',
					instagram: 'iam_billionaire',
					tiktokCount: '0.6 Millions Followers',
					tiktok: 'laurent.jlc',
					twitterCount: ' Millions Followers',
					twitter: '',
					facebookCount: ' Followers',
					facebook: 'julientantiplein',
					snapchatCount: '',
					snapchat: '',
					copyright: '',
				},
				{
					id: 'kamila',
					name: 'Kamila Tir',
					job: '',
					instagramCount: '2.5 Millions Followers',
					instagram: 'kamilaofficiel',
					tiktokCount: '2.5 Millions Followers',
					tiktok: '',
					twitterCount: ' Millions Followers',
					twitter: '',
					facebookCount: ' Followers',
					facebook: 'julientantiplein',
					snapchatCount: '',
					snapchat: 'kamabdelali',
					copyright: '',
				},
				{
					id: 'nore',
					name: 'Noré Abdelali',
					job: '',
					instagramCount: '0.8 Millions Followers',
					instagram: 'noreofficiel',
					tiktokCount: ' Millions Followers',
					tiktok: '',
					twitterCount: ' Millions Followers',
					twitter: '',
					facebookCount: ' Followers',
					facebook: 'julientantiplein',
					snapchatCount: '',
					snapchat: 'noreabdelali',
					copyright: '',
				},
				{
					id: 'hillary',
					name: 'Hillary Vanderosieren',
					job: '',
					instagramCount: '2.1 Millions Followers',
					instagram: 'hillaryoff',
					tiktokCount: ' Millions Followers',
					tiktok: '',
					twitterCount: ' Millions Followers',
					twitter: '',
					facebookCount: ' Followers',
					facebook: 'julientantiplein',
					snapchatCount: '',
					snapchat: 'shogunnette',
					copyright: '',
				},
				{
					id: 'giovanni',
					name: 'Giovanni Bonamy',
					job: '',
					instagramCount: '0.6 Millions Followers',
					instagram: 'gioboyparis',
					tiktokCount: '0.3 Millions Followers',
					tiktok: 'gioboyparis',
					twitterCount: ' Millions Followers',
					twitter: '',
					facebookCount: ' Followers',
					facebook: 'julientantiplein',
					snapchatCount: '',
					snapchat: 'gioboyparis',
					copyright: '',
				},
			],
		}
	},
	methods: {

	},
	mounted() {
		this.showFirst = true
		setTimeout(() => {
			this.showSecond = true
		}, 200)
		setTimeout(() => {
			this.showThird = true
		}, 600)
	},
	beforeRouteLeave(to, from, next) {
		this.showFirst = false
		setTimeout(() => {
			next()
		}, 300)
	},
}
</script>
